import { useSyncExternalStore } from 'react';
import { Link } from 'react-router';
import { UploadIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/use-auth';
import { useUploadBatchStore } from '@/hooks/upload-batch-context';
import { projectPath } from '@/lib/routes';

/** Links back to the receipt of uploads started in this tab. */
export function UploadActivityIndicator() {
  const store = useUploadBatchStore();
  const { current } = useSyncExternalStore(store.subscribe, store.getActivity, store.getActivity);
  const { user } = useAuth();
  if (current === null || user?.tenant_slug == null) return null;
  const label = current.isSending ? 'Uploads in progress' : 'Uploads';
  return <Button asChild size="sm" variant="ghost">
    <Link to={projectPath(user.tenant_slug, current.projectId, '/upload-documents')} aria-label={label}
      onClick={() => { store.select(current.projectId, current.batchId); }}>
      <UploadIcon data-icon="inline-start" />
      {/* Yields in a narrow app header like the other utilities; the link keeps its name. */}
      <span className="hidden sm:inline @max-[24rem]/header:hidden">{label}</span>
    </Link>
  </Button>;
}
